module.exports = __webpack_public_path__ + "img/no-data-easy.357d6c13.png";